import React from 'react'
import { Helmet } from 'react-helmet'

import buildTags from '@/features/seo/meta/buildTags'

function DefineSeo(props) {
  const {
    title,
    noindex = false,
    nofollow,
    description,
    keywords,
    canonical,
    openGraph,
    facebook,
    twitter,
    additionalMetaTags,
    titleTemplate,
    mobileAlternate,
    languageAlternates,
  } = props

  return (
    <Helmet>
      {buildTags({
        title,
        noindex,
        nofollow,
        description,
        keywords,
        canonical,
        facebook,
        openGraph,
        additionalMetaTags,
        twitter,
        titleTemplate,
        mobileAlternate,
        languageAlternates,
      })}
    </Helmet>
  )
}

export default DefineSeo
